"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const style_1 = __importDefault(require("./style"));
const PrimaryButton = (props) => {
    var _a;
    return (react_1.default.createElement("button", { className: `${style_1.default} ${(_a = props.className) !== null && _a !== void 0 ? _a : ''}`, style: props.style }, props.children || 'Primary Button'));
};
exports.default = PrimaryButton;
//# sourceMappingURL=index.js.map